<template>
    <!-- TAB：配置单证字段 -->
    <div class="editTexts">
        <div class="target">
            <template v-if="editTemplate && editTemplate.ruleMap">
                <el-button size="small" type="test" icon="el-icon-plus" @click="addFn">添加关联字段</el-button>
                <!-- 折叠面板 手风琴 -->
                <editCollapse :mainInfo="mainInfo" :pane="activeName" @on-delete="deleteHandle" ref="editMainField">
                </editCollapse>
                <!-- <AddFiledBtn></AddFiledBtn> -->
            </template>
            <template v-else>
                <div class="failed">暂无识别结果</div>
            </template>
        </div>
        <el-dialog title="添加关联字段" top="20px" :visible.sync="visibility" :modal="true" :close-on-click-modal="false"
            width="40%" class="fieldDialog filed" :append-to-body="true" ref="commitDialog">
            <div class="content">
                <el-transfer class="filed-transfer" style="margin: 10px;height: 500px" filterable
                    :titles="['字段表', '类型对应字段']" v-model="value" :button-texts="['到左边', '到右边']" :props="{
              key: 'value',
              label: 'desc'
            }" :data="filedData">
                </el-transfer>
            </div>
            <div class="footer" style="text-align: center;margin-top: 30px">
                <el-button type="primary" class="cancel" @click="visibility = false">关闭</el-button>
                <el-button type="test" class="" @click="saveFn">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

    import _ from 'lodash'

    import bus from '@/assets/js/bus'
    import busType from '@/assets/js/busType'

    import AddFiledBtn from './AddFiledBtn'
    import editCollapse from './editCollapse'
    import CollapseRuleVue from '../testPage/CollapseRule.vue'

    export default {
        name: 'editTexts',
        mixins: [],
        props: {
            mainInfo: Array
        },
        data() {
            return {
                activeName: 'second',
                currentArray: [],
                visibility: false,
                filedData: [],
                value: []
            }
        },
        computed: {
            ...mapState(['labelState']),
            ...mapGetters(['editTemplate', 'groupList'])
        },
        components: {
            AddFiledBtn,
            editCollapse
        },
        watch: {},
        activated() {
            bus.$emit(busType.RESETINDENTITY)
        },
        mounted() {
            //记录滚动位置
            let editTexts = document.querySelector('.editTexts')
            if (editTexts) {
                editTexts.addEventListener('scroll', e => {
                    this.$utils.storage(
                        'BL_ORIGIN_TEMPLATE_editTextsCROLL',
                        editTexts.scrollTop
                    )
                })
            }
        },
        methods: {
            deleteHandle(item) {
                let delValuenumber = 1 //存储要删除字段是否在已分组字段，以及是否是首字段
                this.currentArray = item
                this.delValue = this.currentArray[1].fieldRuleList[0].name
                if (this.groupList && this.groupList.length) {
                    for (let i = 0; i < this.groupList.length; i++) {
                        if (this.delValue == this.groupList[i].fieldName) {
                            if (this.groupList[i].primary) {
                                delValuenumber = 3
                            } else {
                                delValuenumber = 2
                            }
                        }
                    }
                }
                //不在已分组字段
                if (delValuenumber == 1) {
                    this.$common.deleteDialog({
                        title: '确认删除该字段吗？',
                        content: '删除后会将该字段创建的所有规则均删除！',
                        confirm: () => {
                            this.deleteConfirmDialog()
                        }
                    })
                }
                //在分组字段，不是首字段
                if (delValuenumber == 2) {
                    this.$common.deleteDialog({
                        title: '确认删除该字段吗？',
                        content:
                            '该字段已被分组，删除该字段，已添加分组内的字段也会被删除，是否要修改该字段？',
                        confirm: () => {
                            this.$store.dispatch('setEditpageTab', 'three')
                        }
                    })
                }
                //在分组字段，是首字段
                if (delValuenumber == 3) {
                    this.$common.deleteDialog({
                        title: '确认删除该字段吗？',
                        content:
                            '该字段已被分组，且是已分组的“首字段”，删除该字段，已添加分组则会被删除掉，是否要修改“首字段”？',
                        confirm: () => {
                            this.$store.dispatch('setEditpageTab', 'three')
                        }
                    })
                }
            },
            closeCollapse() {
                this.$refs.editMainField.closeName()
            },
            deleteConfirmDialog() {
                let url = this.$resource.deleteField
                    .replace('{templateId}', this.editTemplate.templateId)
                    .replace('{fieldName}', encodeURIComponent(this.currentArray[0]))

                this.$axios({
                    url: url,
                    method: 'delete'
                })
                    .then(res => {
                        delete this.editTemplate.ruleMap[this.currentArray[0]]

                        // 重新调整mainInfo
                        this.$emit('on-delete', this.currentArray[0])

                        // =>EditPage.vue
                        bus.$emit(busType.RESETINDENTITY, 'DocFields')

                        this.closeCollapse()
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            async updataFileds() {
                let id = this.$route.query.id
                let temurl = this.$resource.getTemplateInfo.replace('{id}', id)
                let resData = await this.$axios({
                    url: temurl,
                    method: 'get'
                })
                let mainKey = Object.keys(resData.data.data.ruleMap)
                let filedArr = []
                //console.log(mainKey)
                let url = this.$resource.listDityCategoryRelationUsed.replace(
                    '{categoryId}',
                    this.editTemplate.subTypeRule.categoryId
                )
                this.$axios({
                    url: url,
                    method: 'post'
                })
                    .then(res => {
                        this.$nextTick(() => {
                            let arr = res.data.data
                            let filterArr = arr.filter(function (v, index, arr) {
                                return mainKey.includes(v.dityCode) === false
                            })
                            //console.log(filterArr, 'filterArr')
                            if (filterArr.length > 0) {
                                filterArr.forEach(e => {
                                    filedArr.push({
                                        fieldRuleList: [
                                            {
                                                title: e.dityName,
                                                name: e.dityCode,
                                                dictTypeId: e.id,
                                                priority: 'MEDIUM',
                                                keywords: [],
                                                keywordFormatSet: [],
                                                position: [],
                                                nearPosition: '',
                                                nearMinDistance: 0,
                                                nearMaxDistance: 160,
                                                lastRowKeywords: [],
                                                regexpValueFormatSet: [],
                                                areas: [],
                                                caseSensition: false,
                                                useTable: false,
                                                nearRowMerge: 0,
                                                rowKeyword: []
                                            }
                                        ],
                                        fieldFilterRule: {
                                            singleValue: true,
                                            valueType: '',
                                            valuePolicy: '',
                                            ignoreRowKeywords: [],
                                            removeValueKeyword: [],
                                            removeValueFormatKeyword: [],
                                            valueContains: [],
                                            valueFormatSet: [],
                                            valueNoContains: [],
                                            valueNoFormatSet: [],
                                            minLength: '',
                                            maxLength: 100,
                                            uniqValue: false,
                                            deleteRow: '',
                                            minValue: '',
                                            maxValue: 5000000
                                        },
                                        addField: true
                                    })
                                })

                                let url = this.$resource.editTemplate.replace(
                                    '{templateId}',
                                    this.editTemplate.templateId
                                )

                                this.$axios({
                                    url: url,
                                    method: 'put',
                                    data: filedArr
                                })
                                    .then(res => {
                                        // this.$message.success('添加成功')
                                    })
                                    .catch(e => { })
                            }
                        })
                    })
                    .catch(e => { })


                // setTimeout(() => {
                //     this.mainInfo = Object.entries(this.editTemplate.ruleMap)
                // }, 1000);
            },
            addFn() {
                this.visibility = true
                this.init()
            },
            init() {
                this.filedData = []
                this.value = []
                //console.log(this.editTemplate.subTypeRule)
                this.value = []
                let url = this.$resource.listTemplateCategoryRelation.replace(
                    '{categoryId}',
                    this.$route.query.ruleId
                )
                this.$axios({
                    url: url,
                    method: 'get'
                })
                    .then(res => {
                        this.$nextTick(() => {
                            let arr1 = res.data.data.dictCategoryAllList
                            let arr2 = res.data.data.dictTemplateUsedList
                            if (arr1.length > 0) {
                                for (let i = 0; i < arr1.length; i++) {
                                    this.filedData.push({
                                        value: arr1[i].dityCode,
                                        desc: arr1[i].dityName
                                    })
                                }
                            }
                            if (arr2.length > 0) {
                                arr2.forEach(e => {
                                    this.value.push(e.dityCode)
                                })
                            }
                        })
                    })
                    .catch(e => { })
            },
            async saveFn() {
                let arr = []
                let url = this.$resource.setTemplateDictType.replace(
                    '{categoryId}',
                    this.$route.query.ruleId
                )
                let newArr = []
                this.filedData.forEach(e => {
                    if (this.value.includes(e.value)) {
                        newArr.push({
                            "dityCode": e.value,
                            "dityName": e.desc
                        })
                    }
                })
                await this.$axios({
                    url: url,
                    method: 'post',
                    data: { dictTemplateUsedList: newArr }
                }).then(res => {
                    this.visibility = false
                    this.$message.success('保存成功！')
                })


                let url111 = this.$resource.getTemplateInfo.replace('{id}', this.$route.query.id)

                await this.$axios({
                    url: url111,
                    method: 'get'
                }).then(resData => {
                    let obj = _.cloneDeep(resData.data.data.ruleMap)
                    //console.log(_.cloneDeep(resData.data.data.ruleMap), 222)
                    let arr = []
                    let newObj = {
                        _editableTabs: [{
                            name: "1",
                            result: true,
                            title: "规则1",
                            validator: true
                        }],
                        _editableTabsValue: "1",
                        _tablen: 1,
                    }
                    let newObj2 = {
                        _edited: false,
                        _huoqu: true,
                        _rectangleList: [],
                        _shaixuan: false,
                        _sourceData: [],
                        _testShow: false,
                        _testWord: ""
                    }
                    for (let key in obj) {
                        arr.push([obj[key].name,
                        obj[key], newObj, newObj2
                        ])
                    }
                    this.mainInfo = arr
                    //console.log(this.mainInfo, 111)
                    //console.log(arr, 222)
                    // this.mainInfo = [_.cloneDeep(resData.data.data.ruleMap)]
                })

            }
        }
    }
</script>
<style>
    .editTexts::-webkit-scrollbar-thumb {
        background: transparent;
    }

    .editTexts.roll::-webkit-scrollbar-thumb {
        background: #cccccc;
    }

    .editTexts {
        /*padding-bottom: 60px;*/
        position: relative;
        overflow-y: auto;
        height: calc(100%);
        padding: 0 20px;

        .el-button--add {
            float: right;
        }

        .target {
            position: relative;
            margin: 10px 0;
            /*padding:0 20px;*/
            padding-bottom: 180px;

            button {
                margin-bottom: 10px;
            }
        }

        .failed {
            line-height: 36px;
            text-align: center;
        }
    }

    .filed-transfer {
        /* height: calc(100% - 100px); */
        height: 100%;
        display: flex;
        justify-content: space-between;

        .el-transfer__buttons {
            padding: 0 10px !important;
        }

        .el-transfer-panel {
            width: 270px !important;
        }

        .el-transfer-panel__body,
        .el-transfer-panel,
        .el-transfer-panel__list {
            height: calc(100% - 50px) !important;
        }

        .el-transfer-panel .el-transfer-panel__footer {
            text-align: right;
        }

        .el-transfer__buttons {
            .el-button {
                display: block;
                margin-left: 0;

                span {
                    margin: 0;
                }
            }
        }
    }

    .fieldDialog.filed {

        .filed-transfer .el-transfer-panel__body,
        .filed-transfer .el-transfer-panel,
        .filed-transfer .el-transfer-panel__list {
            /* height: 400px !important; */
        }

        .el-dialog__body {
            padding: 10px !important;
        }

    }
</style>